export class GeneralApplicationRequest {

  constructor() {
    this.membershipLevel = -1;

    this.isAlaskanOwned = false;
    this.isAsianOwned = false;
    this.isBlackOwned = false;
    this.isDisabilityOwned = false;
    this.isHispanicOwned = false;
    this.isLGBTQOwned = false;
    this.isVeteranOwned = false;
    this.isWomenOwned = false;
    this.isOtherMinorityOwned = false;
    this.noneOfTheAbove = false;
    this.paymentOptions = 1;
    this.autoRenew = false;
  }

  //Step one
  applicantFirstName: string;
  applicantLastName: string;
  applicantEmail: string;
  applicantPhoneNumber: string;
  jobTitle: string;
  referredBy: string;

  applicantIsBillingContact: boolean
  billingContactFirstName: string
  billingContactLastName: string
  billingContactEmail: string
  billingContactPhone: string

  applicantIsKeyContact:boolean
  keyContactFirstName: string
  keyContactLastName: string
  keyContactEmail: string
  keyContactPhone: string

  brokerName: string
  brokerEmail: string

  //Step two
  companyName: string;
  numberOfEmployees: number;
  businessPhone: string;
  businessAdress: string;
  city: string;
  state: string;
  zip: string;
  website: string;

  isAlaskanOwned: boolean
  isAsianOwned: boolean
  isBlackOwned: boolean
  isDisabilityOwned: boolean
  isHispanicOwned: boolean
  isLGBTQOwned: boolean
  isVeteranOwned: boolean
  isWomenOwned: boolean
  isOtherMinorityOwned: boolean
  noneOfTheAbove: boolean

  isMinorityOwnedCertified: number
  minorityOwnedCertificates: number[]

  description:string;
  industry: string;
  privateAddress: boolean;

  //step three

  membershipLevel: number
  startupYear: number
  paymentOptions: number

  cardNumber: string;
  cardExpiration: string;
  cvv: string;

  routingNumber: string;
  accountNumber1: string;
  accountNumber2: string;

  paymentDue:number;

  autoRenew: boolean
  declinePacDonation: boolean

}
